import React from "react";
import Card from "src/components/Card";
import { v4 } from "uuid";
import { RCCCheckBox } from "react-common-components";
import { useAuth } from "src/context/Auth/context";
import { ICardIndicators } from "./interface";
import TooltipIndicators from "../TooltipIndicatorPanel/tooltip";
import { IIndicatorsLevel } from "../interface";
import { useIndicatorsPanel } from "../../indicatorsPanelContext";

const CardIndicator: React.FC<ICardIndicators> = ({
	data,
	options,
	openValuesOfPeriodIndicator,
	defaultChecked
}) => {
	const { administrator, superUser } = useAuth();
	const {showCheckboxes, addSelectedCheckboxId, selectedCheckboxesId } = useIndicatorsPanel();
	let color: "purple" | "blue" | "orange" = "purple";

	if(data.iqc001Nivel === IIndicatorsLevel.OPERATIONAL)
		color = "orange";
	else if(data.iqc001Nivel === IIndicatorsLevel.TACTIC)
		color = "blue";

	return(
		<Card
			color={color}
			options={options(data)}
			title={`${data.iqc001Descricao}`}
			hidePercentage
			maxCards="4"
			customHeader={<>
				<div style={{ display: "flex" }}>
					{showCheckboxes && (
						<RCCCheckBox
							name={`selectIndicator-${v4()}`}
							onChange={() => addSelectedCheckboxId(data.iqc001Id)}
							defaultChecked={defaultChecked || selectedCheckboxesId.includes(data.iqc001Id)}
							styleInline={{ checkbox: "margin: 0; margin-right: 2px; margin-left: -0.8rem;" }}
						/>
					)}		
					<span className="title" title={data.iqc001Descricao}>{data.iqc001Descricao}</span>
				</div>
				<div>{options(data)}</div>
			</>}
		>	
			<TooltipIndicators 
				onClick={() => {
					if(!openValuesOfPeriodIndicator || (!administrator && !superUser && data.permission < 2))
						return;
					const row = data.values[0];
					openValuesOfPeriodIndicator(data.iqc001Id, data.iqc001Descricao, row.periodId || 0);
				}}
				value={{ ...data.values[0], iqc001Formaaval: data.iqc001Formaaval, metrics: data.metrics }} 
				styleInline={`
						background: transparent;
						border: none;
						box-shadow: none;
						width: 100%;
						min-width: 100%;
						padding: 0;

						&:hover{
							cursor: pointer;
						}

						>div{
							padding: 0;
							
							&:first-child{
								border: none;
							}
						}
					`}
			/>
		</Card>
	);};

export default CardIndicator;
